import React from 'react';
import { Link } from 'react-router-dom';

const LandingFooter = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="text-center text-gray-300 text-sm">
          <p>
            © 2025 - Global Trademark Pro. All rights reserved |{' '}
            <Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors">
              Privacy Policy
            </Link>
            {' '}|{' '}
            <Link to="/terms-conditions" className="hover:text-emerald-400 transition-colors">
              Terms & Conditions
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;